import { SVGProps } from 'react';

export const DocumentNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="141"
    height="141"
    viewBox="0 0 141 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(40.5, 40.5)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2476 17.7178H15.1858V10.1251H20.2476V17.7178ZM12.6547 17.7178H7.59289V10.1251H12.6547V17.7178ZM40.4946 39.3228V18.6326C40.4946 17.4532 40.0795 16.3016 39.3228 15.393L28.0121 1.82226C27.0479 0.663099 25.6306 0 24.1221 0H5.06183C2.27023 0 0 2.27023 0 5.06183V45.5564C0 48.348 2.27023 50.6183 5.06183 50.6183H35.4328V50.6183C35.4328 46.1284 37.3942 42.1043 40.4946 39.3228V39.3228Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 44.8131L56.4213 41.2344L50.6179 47.0378L44.8146 41.2344L41.2358 44.8131L47.0392 50.6165L41.2358 56.4199L44.8146 59.9986L50.6179 54.1952L56.4213 59.9986L60 56.4199L54.1966 50.6165L60 44.8131Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
